/**
 *
 * Collapse
 *
 */

import "./styles.scss";

import React, { Component } from "react";

/* eslint-disable react/prefer-stateless-function */
class Collapse extends Component<any, any> {
	render() {
		const { children, expandedChildren, expanded } = this.props;
		return (
			<div className="CollapseRoot">
				<div className="CollapseContainer">
					{children}
				</div>
				<div className={`CollapsedBlock${expanded ? " --expanded" : ""}`}>
					<div>
						{expandedChildren}
					</div>
				</div>
			</div>
		);
	}
}

export default Collapse;
